/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { BehaviorSubject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * @export
 * @class LmsTerminalStatusSubmenuService
 */
@Injectable()
export class LmsTerminalStatusSubmenuService {
    private terminalStatusMenuBS: BehaviorSubject<Array<Object>>;
    terminalStatusMenu: Observable<Array<Object>>;
    terminalStatusMapping: Object;
    count: any;
    terminalStatusList: any;

    /**
     * Creates an instance of LmsTerminalStatusSubmenuService.
     * @memberOf LmsTerminalStatusSubmenuService
     */
    constructor() {
        const terminalStatusList = [
            { 'display': 'IN READY FIELD', value: 'inReadyTrackList', active: true, height: 57 },
            { 'display': 'ON TERMINAL', value: 'onTerminalList', active: true, height: 57 },
            { 'display': 'AT SERVICE CENTER', value: 'atServiceCentreList', active: true, height: 57 },
            { 'display': 'ON PIT', value: 'onPitList', active: true, height: 57 },
            { 'display': 'DUE OUT SHOP', value: 'inShopList', active: false, height: 75 },
            { 'display': 'STORED', value: 'storedAtTerminalList', active: false, height: 75 },
            { 'display': 'NET ALLOCATION', value: 'yardAndLocalList', active: false, height: 57 } 
        ];

        this.terminalStatusMapping = {
            'inReadyTrackList': 'IN READY FIELD',
            'onTerminalList': 'ON TERMINAL',
            'atServiceCentreList': 'AT SERVICE CENTER',
            'onPitList': 'ON PIT',
            'inShopList': 'DUE OUT SHOP',
            'storedAtTerminalList': 'STORED',
            'yardAndLocalList' : 'NET ALLOCATION' 
        };

        this.terminalStatusMenuBS = <BehaviorSubject<Array<Object>>>new BehaviorSubject({});
        this.terminalStatusMenuBS.next(terminalStatusList);
        this.terminalStatusList = terminalStatusList;
        this.terminalStatusMenu = this.terminalStatusMenuBS.asObservable();
        this.count = 4;
    }

    /**
     * This is used to updat status List
     * @param {Array<Object>} statusList
     * @memberOf LmsTerminalStatusSubmenuService
     */
    updateStatusListValue(statusList: Array<Object>) {
        this.setCountValue(statusList);
        this.terminalStatusList = statusList;
        this.terminalStatusMenuBS.next(statusList);
    }

    /**
     * @private
     * @param {Array<Object>} statusList
     *
     * @memberOf LmsTerminalStatusSubmenuService
     */
    private setCountValue(statusList: Array<Object>) {
        let tempCount = 0;
        if (statusList) {
            statusList.forEach((status) => {
                if (status['active']) {
                    tempCount++;
                }
            });
            this.count = tempCount;
        }
    }
}
